/** TrafiFlow canonical anonymous id (`localStorage['_tfdv']`). */
export const TFP_ANON_STORAGE_KEY = '_tfdv';

/** Segment browser anonymous id (`localStorage['ajs_anonymous_id']`). */
export const SEGMENT_ANON_STORAGE_KEY = 'ajs_anonymous_id';

export interface VendorAnonIds {
  segment_anon_id?: string;
  tfp_anon_id?: string;
}

function readStorageValue(key: string): string | undefined {
  if (typeof window === 'undefined') return undefined;
  try {
    const value = window.localStorage.getItem(key);
    const trimmed = value?.trim();
    return trimmed || undefined;
  } catch {
    return undefined;
  }
}

export function readTfpAnonId(): string | undefined {
  return readStorageValue(TFP_ANON_STORAGE_KEY);
}

export function readSegmentAnonId(): string | undefined {
  return readStorageValue(SEGMENT_ANON_STORAGE_KEY);
}

/** Vendor-neutral anon ids for dataLayer context and identify payloads. */
export function getVendorAnonIds(): VendorAnonIds {
  const tfpAnonId = readTfpAnonId();
  const segmentAnonId = readSegmentAnonId();

  return {
    ...(tfpAnonId ? { tfp_anon_id: tfpAnonId } : {}),
    ...(segmentAnonId ? { segment_anon_id: segmentAnonId } : {}),
  };
}
